var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllowLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4226 62.8093C50.9998 62.8093 62.8169 50.9922 62.8169 36.4151C62.8169 21.8379 50.9998 10.0208 36.4226 10.0208C21.8455 10.0208 10.0283 21.8379 10.0283 36.4151C10.0283 50.9922 21.8455 62.8093 36.4226 62.8093Z",
    fill: "#CCE7E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7702 70.8422C62.4954 70.8422 72.0004 61.3372 72.0004 49.612C72.0004 37.8869 62.4954 28.3818 50.7702 28.3818C39.0451 28.3818 29.54 37.8869 29.54 49.612C29.54 61.3372 39.0451 70.8422 50.7702 70.8422Z",
    fill: "white",
    stroke: "#19213E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2412 20.762L21.2596 10.7437",
    stroke: "#19213E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8005 2.00004L18.0635 7.73706L24.9528 14.6264L30.6898 8.88933L23.8005 2.00004Z",
    fill: "white",
    stroke: "#19213E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73702 16.9207L2 22.6577L8.88929 29.547L14.6263 23.81L7.73702 16.9207Z",
    fill: "white",
    stroke: "#19213E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3887 27.2346L31.8314 30.6774",
    stroke: "#19213E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5225 10.0896L24.3014 18.8686C24.1778 20.1334 23.6196 21.3163 22.7221 22.216C21.8245 23.1157 20.6429 23.6765 19.3783 23.8032L10.5879 15.0242C10.7219 13.7603 11.2801 12.5792 12.1715 11.6733C13.0742 10.7773 14.2571 10.2183 15.5225 10.0896Z",
    fill: "#83E0CA",
    stroke: "#19213E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.676 34.5559C19.2895 32.567 18.6468 30.1537 18.8606 27.7386C19.0743 25.3235 20.131 23.0605 21.8454 21.3461C23.5598 19.6317 25.8227 18.5751 28.2378 18.3613C30.6529 18.1475 33.0663 18.7902 35.0552 20.1768L20.676 34.5559Z",
    fill: "#08C296",
    stroke: "#19213E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27298 41.0053C5.11309 39.7722 5.02877 38.5305 5.02051 37.2871",
    stroke: "#00857C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58432 46.5252C6.23836 45.4631 5.95103 44.3827 5.72363 43.2891",
    stroke: "#00857C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56117 51.3338C8.07919 50.4234 7.64311 49.4938 7.25293 48.5452",
    stroke: "#00857C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1262 66.6652C20.3943 64.72 13.7277 59.8322 9.54688 53.0435",
    stroke: "#00857C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7637 23.5625C66.2465 24.7099 66.6566 25.8866 66.9916 27.0856",
    stroke: "#00857C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0664 18.5244C63.6881 19.4507 64.2552 20.4125 64.7648 21.4048",
    stroke: "#00857C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8428 14.4392C60.5463 15.1705 61.2127 15.9365 61.8395 16.7344",
    stroke: "#00857C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8789 4.85633C44.8519 4.66633 52.5829 7.60303 58.419 13.0386",
    stroke: "#00857C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9281 32.9724H53.6329L50.1902 36.4151V38.7103H46.7474L43.3047 41.0055V43.3006H49.0426L50.1902 44.4482H52.4853L54.7805 46.7434H59.3708L61.6659 49.0385L63.9611 46.7434H68.5514",
    stroke: "#19213E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7817 51.3338H52.4865L49.0438 47.8911H44.4535L41.0107 51.3338L43.3059 57.0717H46.7486L49.0438 59.3669V65.1048L50.1914 66.2524H52.4865L55.9293 62.8096V59.3669L59.372 55.9242L54.7817 51.3338Z",
    stroke: "#19213E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllowLocation);
export default __webpack_public_path__ + "static/media/allow-location.67f1fbdc99a6edf7ef2a076ba6d29cca.svg";
export { ForwardRef as ReactComponent };